import { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./StepIndicator.module.scss";

interface StepIndicatorProps {
  value: number;
  total: number;
  className?: string;
}

const StepIndicator: FC<StepIndicatorProps> = ({ value, total, className }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <span className={styles.title}>
        {t("stepTitle", { number: t(`steps.${value - 1}` as any) })}
      </span>
      <div className={styles.dots}>
        {[...Array(total)].map((e, i) => (
          <div
            key={i}
            className={`${styles.dot} ${i < value ? styles.active : ""}`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
